import React from "react"
import ReactPaginate from "react-paginate"
import { navigate } from "gatsby"
import { Grid } from "../../bits"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"
import { paginate, previous, next } from "./Pagination.module.css"

const ITEMS_PER_PAGE = 24

const Pagination = ({ items, disabled, columns, location }) => {
  const { pathname, search } = location
  const urlParams = new URLSearchParams(search)
  const [page, setPage] = React.useState(urlParams.get("p") ?? 1)
  const { t } = useTranslation()
  const start = (page - 1) * ITEMS_PER_PAGE
  const end = start + ITEMS_PER_PAGE

  const handlePageChange = React.useCallback(
    ({ selected }) => {
      const page = selected + 1

      if (setPage) {
        setPage(page)
      }

      if (page === 1) {
        navigate(pathname)
      } else {
        const url = new URL(window.location.href)
        url.searchParams.set("p", page)

        navigate(url.toString().replace(process.env.GATSBY_SITE_URL, ""))
      }
    },
    [pathname, setPage]
  )

  const paginatedItems = disabled ? items : items.slice(start, end)

  return (
    <div className="pagination">
      <Grid columns={columns} gap="large">
        {paginatedItems}
      </Grid>
      {!disabled && items.length > ITEMS_PER_PAGE && (
        <ReactPaginate
          className={paginate}
          breakLabel="..."
          onPageChange={handlePageChange}
          pageCount={Math.ceil(items.length / ITEMS_PER_PAGE)}
          forcePage={page - 1}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          hrefBuilder={page => {
            if (typeof window === "undefined") {
              if (page === 1) {
                return pathname
              }

              return `${pathname}?p=${page}`
            } else {
              const url = new URL(process.env.GATSBY_SITE_URL + pathname)

              url.searchParams.set("p", page)

              if (page === 1) {
                url.searchParams.delete("p")
              }

              return url.toString()
            }
          }}
          previousClassName={previous}
          nextClassName={next}
          nextLabel={
            <>
              <span>{t("next")}</span>
              <ChevronRightIcon style={{ width: "1.3em" }} />
            </>
          }
          previousLabel={
            <>
              <ChevronLeftIcon style={{ width: "1.3em" }} />
              <span>{t("previous")}</span>
            </>
          }
          renderOnZeroPageCount={null}
        />
      )}
    </div>
  )
}

Pagination.propTypes = {
  items: PropTypes.array,
  teaserProps: PropTypes.object,
  disabled: PropTypes.bool,
  isVisibleOnTopOfPage: PropTypes.bool,
  columns: PropTypes.oneOf([2, 3, 4, "2_3"]),
}

Pagination.defaultProps = {
  disabled: false,
  columns: 3,
  isVisibleOnTopOfPage: false,
}

export { Pagination }
